/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import Link from 'next/link';
import parse from 'html-react-parser';
import http from "utilities/http";

export default function ProfessionalInfo({ item }) {
    const name = item.display_name || item.fullname;
    const business = item.infoProfessional;
    const logo = item.avatar;
    const link = `/thanh-vien/u/${item.id}` || item.wall_url;
    const bio = item.bio;

    return <>
        <Link href={link} passHref={true}>
            <div className="pro-card cursor-pointer">
                <p className="pro-card-title">Chuyên gia trong bài viết</p>

                <div className="pro-card-content">
                    <div className="pro-info">
                        <img className="pro-logo" src={logo} />
                        <div className="pro-name-business">
                            <p className="pro-name">{name}</p>
                            {business != 'Khác' && <p className="pro-business">{business}</p>}
                        </div>
                    </div>
                    <div className="pro-bio">
                        <p className="pro-bio-txt" style={{whiteSpace: 'pre-wrap'}}>{parse(bio)}</p>
                    </div>
                </div>
            </div>
        </Link>
    </>;
}
